import { Package } from "lucide-react";

interface StatusPrioritySectionProps {
  formData: any;
  setFormData: (data: any) => void;
}

const StatusPrioritySection: React.FC<StatusPrioritySectionProps> = ({
  formData,
  setFormData
}) => {
  return (
    <div className="bg-gradient-to-r from-indigo-50 to-blue-50 rounded-xl p-4 border border-indigo-200 shadow-sm">
      <div className="flex items-center mb-3">
        <div className="p-2 bg-indigo-500 rounded-lg mr-3">
          <Package className="w-4 h-4 text-white" />
        </div>
        <h3 className="font-semibold text-gray-800 text-lg">Status</h3>
      </div>

      <div className="space-y-3">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Status transport
          </label>
          <select
            value={formData.status}
            onChange={(e) =>
              setFormData({ ...formData, status: e.target.value as any })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
          >
            <option value="in_asteptare">În așteptare</option>
            <option value="in_incarcare">În încărcare</option>
            <option value="pe_drum">Pe drum</option>
            <option value="livrat">Livrat</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Prioritate
          </label>
          <select
            value={formData.prioritate}
            onChange={(e) =>
              setFormData({ ...formData, prioritate: e.target.value as any })
            }
            className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
          >
            <option value="normala">Normală</option>
            <option value="urgenta">Urgentă</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default StatusPrioritySection;